import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form, Input, Button } from 'antd';

import { reducer, state } from '../../../redux/sagas/aws-cognito-redux-saga';
import { clearCurrentUser } from '../../../redux/actions/user';

import Placeholder from '../../../components/Placeholder';
import Image from '../../../components/ContentfulImage';

import {
  Container,
  HeroImage,
  RightContents,
  RigthContentsInner,
  Title,
  FormGroup,
  FormWrapper,
  AInputCover,
  SubmitCover,
  ErrorMessage,
  TextBottom,
  Spinner,
} from './LoginPage.style';
import { TABLET_P } from '../../../constants';

class LoginPage extends PureComponent {
  state = {
    code: '',
    loading: false,
    signInError: '',
  };

  componentWillMount() {
    this.props.init();
  }

  componentWillReceiveProps(nextProps) {
    const { auth, clearCurrentUser } = nextProps;
    const { locale, history } = this.props;

    if (this.props.auth.info && this.props.auth.info.username && !auth.info.username) {
      clearCurrentUser();
    }

    if (auth.isSignedIn !== state.AUTH_SUCCESS) {
      this.setState({
        loading: false,
        code: '',
        signInError: (auth.error.message && this.props.copy.errorMessage.login) || '',
      });
    }

    if (auth.isSignedIn === state.AUTH_SUCCESS && this.props.auth.isSignedIn === state.AUTH_UNKNOWN) {
      history.push(`/${locale}/salon-consultation/home`);
    }
  }

  handleSignIn = e => {
    const { code, loading } = this.state;
    const { auth, signIn } = this.props;
    e.preventDefault();
    if (loading) return;
    this.setState(
      {
        loading: true,
        signInError: '',
      },
      () => {
        if (auth.isConfirmed === state.AUTH_SUCCESS) {
          this.props.form.validateFields((err, values) => {
            if (!err) {
              const { email, password } = values;
              signIn(email, password);
            }
          });
        } else {
          this.props.form.validateFields((err, values) => {
            if (!err) {
              const { email, password } = values;
              signIn(email, password, code);
            }
          });
        }
      }
    );
  };
  render() {
    const { locale, copy, backgroundImage } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { loading, signInError } = this.state;
    const loginData = (copy.login && copy.login) || {};
    const errorCopy = copy.errorMessage || {};
    return (
      <div>
        <Container>
          <HeroImage>
            {(!!backgroundImage && (
              <Image src={backgroundImage} options={{ w: '100%', h: '100%', objectFit: 'cover' }} />
            )) || <Placeholder w="312px" h="100%" />}
          </HeroImage>
          <RightContents>
            <RigthContentsInner>
              <Title>
                <div className="title">{loginData.title1 || <Placeholder w="248px" h="30px" />}</div>
                <div className="lead">{loginData.title2 || <Placeholder w="151px" h="24px" />}</div>
              </Title>
              <FormGroup>
                <Form onSubmit={this.handleSignIn}>
                  <FormWrapper>
                    {!loginData.emailPlaceholderText ? (
                      <Placeholder w={window.innerWidth > TABLET_P ? '365px' : '100%'} h="68px" />
                    ) : (
                      <Form.Item>
                        {getFieldDecorator('email', {
                          rules: [{ required: true, message: (errorCopy && errorCopy.notEnteredEmail) || '' }],
                        })(
                          <AInputCover>
                            <Input type="email" placeholder={loginData.emailPlaceholderText} />
                          </AInputCover>
                        )}
                      </Form.Item>
                    )}
                  </FormWrapper>
                  <FormWrapper>
                    {!loginData.passwordPlaceholderText ? (
                      <Placeholder w={window.innerWidth > TABLET_P ? '365px' : '100%'} h="68px" />
                    ) : (
                      <Form.Item>
                        {getFieldDecorator('password', {
                          rules: [{ required: true, message: (errorCopy && errorCopy.notEnteredPassword) || '' }],
                        })(
                          <AInputCover>
                            <Input type="password" placeholder={loginData.passwordPlaceholderText} />
                          </AInputCover>
                        )}
                      </Form.Item>
                    )}
                  </FormWrapper>
                  {signInError && <ErrorMessage>{signInError}</ErrorMessage>}
                  <FormWrapper>
                    {!loginData.logInCtaLabel ? (
                      <Placeholder w={window.innerWidth > TABLET_P ? '365px' : '100%'} h="60px" />
                    ) : (
                      <SubmitCover disabled={loading}>
                        <Button htmlType="submit" loading={loading}>
                          {loading ? <Spinner /> : loginData.logInCtaLabel}
                        </Button>
                      </SubmitCover>
                    )}
                  </FormWrapper>
                </Form>
                <Link
                  href={`/${locale}/salon-consultation/forgot-password`}
                  to={`/${locale}/salon-consultation/forgot-password`}
                >
                  <TextBottom>{loginData.forgotPasswordCtaLabel || <Placeholder w="260px" h="24px" />}</TextBottom>
                </Link>
                <Link href={`/${locale}/salon-consultation/sign-up`} to={`/${locale}/salon-consultation/sign-up`}>
                  <TextBottom>{loginData.signUpCtaLabel || <Placeholder w="79px" h="26px" />}</TextBottom>
                </Link>
              </FormGroup>
            </RigthContentsInner>
          </RightContents>
        </Container>
      </div>
    );
  }
}

LoginPage.defaultProps = {
  copy: {},
};

LoginPage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    isSignedIn: PropTypes.string,
    info: PropTypes.shape({
      username: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFields: PropTypes.func,
  }).isRequired,
  init: PropTypes.func.isRequired,
  signIn: PropTypes.func.isRequired,
  clearCurrentUser: PropTypes.func.isRequired,
};

const mapState = state => ({
  locale: state.locale,
  auth: state.auth,
  backgroundImage: state.salonConsultaionSiteOptions.backgroundImage,
  copy: state.salonConsultaionSiteOptions.siteCopy,
});

const mapDispatch = dispatch => ({
  init: () => dispatch(reducer.init()),
  signIn: (username, password, code) => dispatch(reducer.signIn(username, password, code)),
  clearCurrentUser: () => dispatch(clearCurrentUser()),
});
const LoginPageForm = Form.create()(LoginPage);

export default connect(mapState, mapDispatch)(LoginPageForm);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/LoginPage/LoginPage.js